import { QuickFilters } from 'state/auctions.slice/constants';

export const inProgressQuickFilters = [QuickFilters.outbid, QuickFilters.inTheLead];

export const typeToQuickFilters = {
  following: [],
  in_prog: inProgressQuickFilters,
  won: [],
  didnt_win: [],
  all: [],
};

export const MY_AUCTION_TYPES = ['in_prog', 'won', 'didnt_win', 'all'];
